import { Tag } from '@chakra-ui/react'
import { startCase } from 'lodash'

export function BatchStatusTag({ status }: { status: string }) {
  const statusColor =
    {
      completed_with_errors: 'orange',
      completed: 'green',
      failed: 'red',
      pending: 'yellow',
    }[status] || 'gray'

  return (
    <Tag size="sm" colorScheme={statusColor}>
      {startCase(status)}
    </Tag>
  )
}
